const libraryFiles = require.context('../libraries', true, /.*/);
libraryFiles.keys().forEach(libraryFiles);
